<template>
  <div :class="getCustomClass()">
    <div class="part5">
      <div class="part_section" id="section3"></div>
      <div class="blur_bd_title">费用<br />说明</div>
      <div class="part5_bd">
        <dl class="text_box fix">
          <dt class="text_hd f-fl">船票费用包含</dt>
          <dd class="text_bd f-fl">
            <span class="text-subtitle">船上免费项目</span>
            <p>
              含船上住宿、自助餐厅、免费餐厅、免费休闲娱乐设施、游泳池、健身房、及免费演出活动等。
              <a :href="shipLink" target="_blank" class="to_ship"
                >了解{{ shipName }}</a
              >
            </p>
          </dd>
          <dd class="text_bd f-fr" v-if="!isHkSpecialCruise">
            <span class="text-subtitle">皇家赠送的岸上观光常规游行程</span>
            <p>
              通过皇家加勒比游轮中国官网预订中国出发航次船票的客人，可享受船方免费赠送的皇家岸上观光常规游（“常规游”，仅适用于特定目的地）或购买船方提供的付费精品游行程（“精品游”）。请您在预订流程中查看详情并选择您所需要的岸上观光行程。
              <!--              我们会根据不同的游轮航线以及停靠港口，为部分航线提供皇家赠送的岸上观光常规游，请您在预定流程中查看详情并选择您所需要的岸上观光行程。-->
            </p>
          </dd>
          <!-- <dd class="text_bd f-fr">
                        <span class="text-subtitle">游轮保险</span>
                        <div v-if="visaContent.insuranceBrief" v-html="visaContent.insuranceBrief"></div>
                    </dd> -->
        </dl>
        <dl class="text_box fix">
          <dt class="text_hd f-fl">船票费用不含</dt>
          <dd class="text_bd f-fl">
            <span class="text-subtitle">游轮服务费</span>
            <p>
              海际套房及以下普通房型服务费为每晚18美金/人，天际套房、星际套房为每晚20.5美金/人。<br />
              游轮服务费于登船后收取，以美金计价方式直接计入您的船卡消费账单中。下船前，船方统一在您与船卡绑定的信用卡中自动扣除。<br />
              没有绑定信用卡的客人，请前往船上Guest Service服务台刷取银联借记卡或者支付美金现金进行结账。<br />
              预订星际套房的客人享有套房礼遇，无需额外支付游轮服务费。<br />
              *游轮服务费可能因船方实际运营需求调整。
              <!--              海际套房及以下普通房型服务费为每晚16美金/人，天际套房为每晚18.5美金/人。<br />-->
<!--              游轮服务费于登船后收取，以美金计价方式直接计入您的船卡消费账单中。下船前，船方统一在您与船卡绑定的信用卡中自动扣除。<br />-->
<!--              没有绑定信用卡的客人，请在航次结束前前往船上Guest-->
<!--              Service服务台刷取银联借记卡或者支付美金现金进行结账。<br />-->
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">前往码头的交通费</span>
            <p>
              前往码头登船的交通、食宿费用需要您自理，请您妥善安排好时间，以免耽误您的出行。
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">船上收费餐饮娱乐</span>
            <p>如：收费餐厅、收费娱乐设施、VIP演出活动坐席等。</p>
          </dd>

          <dd class="text_bd f-fr" v-if="!isHkSpecialCruise">
            <span class="text-subtitle"
              >皇家精品游或私人定制游行程（付费）</span
            >
            <p>
              船方会根据不同的游轮航线以及停靠港口，针对部分目的地提供免费常规游，同时也提供所有目的地的精品游或私人定制游。请您在预订流程中查看详情并选择您所需要的岸上观光行程。
              <!--              我们会根据不同的游轮航线以及停靠港口，为部分航线提供付费皇家精品游或私人定制游，请您在预定流程中查看详情并选择您所需要的岸上观光行程。-->
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">Wi-Fi</span>
            <p>
              船上拥有飞速的卫星通讯技术，提供付费高速上网服务。WiFi您可以前往甲板5层服务中心联系工作人员进行购买，也可以连接船上WiFi后，根据页面提示进行购买，不同船队收费标准不一。
              <!--              船上拥有飞速的卫星通讯技术，提供付费高速上网服务，全程套餐参考价：18美金/晚/1个设备，请于登船首日购买。-->
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">签证</span>
            <p>根据航线不同，客人需要另行支付所需办理的团签费用。</p>
            <p>若您选择自行办理个人旅游签证，所需费用请您自理。</p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">其他收费或自费项目</span>
          </dd>
        </dl>
      </div>
    </div>

    <div class="part5">
      <div class="part_section" id="section4"></div>
      <div class="blur_bd_title">签证及<br />保险</div>
      <div class="part5_bd">

        <dl class="text_box fix" v-if="isHkSpecialCruise">
          <dt class="text_hd f-fl">签证说明</dt>
          <dd class="text_bd f-fl">
            <span class="text-subtitle">香港本地居民：</span>
            <p>
              使用香港永久居民身份证登船。11岁以下儿童需同时携带香港特区护照。
            </p>
          </dd>

          <dd class="text_bd f-fr">
            <span class="text-subtitle">外籍在港居住人士：</span>
            <p>持有本国护照和香港居民身份证登船。</p>
            <p>**护照需保证在航次结束日后仍有6个月以上的有效期。</p>
            <p>旅行证件要求可能会依据香港当局相关规定的调整而更改。**</p>
          </dd>
        </dl>

        <dl class="text_box fix" v-else>
          <dt class="text_hd f-fl">签证说明</dt>
          <dd class="text_bd f-fl">
<!--            <span class="text-subtitle">中国大陆客人护照及签证要求：</span>-->
<!--            <p>-->
<!--              所有客人必须持有在航次结束后仍有6个月以上有效期的护照原件；同时请务必准备好两份护照首页信息页的复印件，A4纸张大小，请勿缩印。-->
<!--            </p>-->
            <div
              v-if="visaContent && visaContent.visaContent"
              v-html="visaContent.visaContent"
              class="insurance_html"
            ></div>
          </dd>

          <dd class="text_bd f-fr">
            <span class="text-subtitle">港澳台及外籍客人护照及签证要求：</span>
            <div
              v-if="visaContent && visaContent.hkGuestContent"
              v-html="visaContent.hkGuestContent"
            ></div>
          </dd>
        </dl>


        <dl class="text_box fix">
          <dt class="text_hd f-fl">保险说明</dt>
          <dd class="text_bd f-fl" v-if="isHkSpecialCruise">
            <div>
              <p>如您有投保个人意外险的需求，您可选择由环亚推出的邮轮境外保险计划，具体可登录环亚网站或致电环亚了解详情：香港出发请致电意外险服务专线：021-63613665。</p>
            </div>
          </dd>
          <dd class="text_bd f-fl" v-else>
            <div
              v-if="visaContent && visaContent.insuranceContent"
              v-html="visaContent.insuranceContent"
            ></div>
          </dd>
        </dl>
      </div>
    </div>
    <div class="part5">
      <div class="part_section" id="section5"></div>
      <div class="blur_bd_title">预订及<br />退改</div>
      <div class="part5_bd">
        <dl class="text_box fix">
          <dt class="text_hd f-fl">预订限制</dt>
          <dd class="text_bd f-fl">
            <span class="text-subtitle">1. 未成年人出行</span>
            <p>
              皇家加勒比游轮规定，中国母港出发的航次，游轮起航当天21周岁以下的乘客为未成年人，必须确保每个舱房中，至少有1位乘客的年龄在21周岁以上；被监护人尽可能与监护人入住同一舱房，否则船方将根据实际情况保留限制未成年人登船的权利。若未成年人不随其父母一起登船出行，必须要提供以下资料(一式两份)：
            </p>
            <p>
              1). 未成年人的出生证复印件或有父母和孩子信息页面的户口簿复印件。
            </p>
            <p>
              2). 其父母及随行监护人必须填写<a
                style="text-decoration: underline; cursor: pointer"
                href="/Themes/Rccl.NewTheme/Content/childrenInfo.pdf"
                target="_blank"
                >授权声明信与随行监护人承诺书</a
              >，请打印该附件并签字携带。
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">2. 婴儿出行</span>
            <p>
              皇家加勒比游轮规定，乘坐游轮旅行的婴儿必须在游轮起航第一天时至少满6个月。对于横跨大西洋、横跨太平洋的航线、夏威夷航线、某些特定的南美航线及特定的陆地游，婴儿在登船当日必须满12个月。任何航线有超过3天及以上的连续海上巡游日，也要求婴儿在开航之日必须满12个月。
            </p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">3. 孕妇出行</span>
            <p>
              在游轮巡游/游轮观光活动开始之日或其后行程的任何时间里妊娠进入第23周的乘客，不得预订游轮巡游或登船。
<!--              在游轮巡游/游轮观光活动开始之日或其后行程的任何时间里妊娠将超过23周（即进入第24周或以上）的乘客，不得预定游轮巡游或登船。-->
            </p>
            <p>
              至游轮行程结束之日妊娠将不超过23周的孕妇，需要出具医院证明（该证明须含有该孕妇怀孕周数并加盖医院公章），在登船当天到主管柜台报备、填写相关表格后方可登船。但游轮公司保留是否允许乘客登船的最终决定权。
            </p>
            <p>乘客如因怀孕需取消预订的，仍遵循预订原有的退改政策。</p>
          </dd>
          <dd class="text_bd f-fr">
            <span class="text-subtitle">4. 长者出行</span>
            <p>
              在皇家加勒比国际游轮对于长者未设年龄限制，但鉴于游轮上的医疗设施及救助措施有限，建议出行前对老人（长者）的健康状况进行评估，并由家人陪护出行，备好常用药品等。
            </p>
          </dd>
          <dd class="text_bd f-fr" v-if="isHkSpecialCruise">
            <span class="text-subtitle">5. 2021年香港复航航次乘客要求</span>
            <p>
              根据政府相关指引以及卫生防控需要，乘客必须同时符合以下条件方可登船：
            </p>
            <p>1. 香港居民</p>
            <p>
              2.
              已在登船日14天前接种2剂新冠疫苗，持有医疗证明不适合接种疫苗或12周岁以下人士除外
            </p>
            <p>3. 登船日前48小以内进行了核酸检测，且报告结果为阴性。</p>
            <p>4. 登船日前14天以内未到访或途经菲律宾或印度。</p>
          </dd>
        </dl>

        <dl class="text_box fix">
          <dt class="text_hd f-fl">退改签说明</dt>
          <dd class="text_bd f-fl">
            <NrpTable
              :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
              :hasNrp="hasNrp"
              :hasRp="hasRp"
              :needTitleBreak="isFromGuestInfo"
              :showNrp="isShowNrp"
              :showRp="isShowRp"
            />
          </dd>
        </dl>

        <dl class="text_box fix" v-if="isBirthday">
          <dt class="text_hd f-fl">生日礼遇退改规则</dt>
          <dd class="text_bd f-fl">
            <!-- <span class="text-subtitle">退改规则：</span> -->
            <p>
              开航前7天（不含）之前，可以免费修改生日礼遇的乘客信息（仅限同舱内）、调整享用生日蛋糕的用餐时间或取消生日礼遇；开航前7天之内，不再接受任何修改或取消，已收取的费用不予退回
              。
            </p>
          </dd>
        </dl>
      </div>
    </div>
    <div class="part5">
      <div class="part_section" id="section6"></div>
      <div class="blur_bd_title">支付及<br />发票</div>

      <div class="part5_bd">
        <dl class="text_box fix">
          <dt class="text_hd f-fl">支付及发票说明</dt>
          <dd class="text_bd f-fl">
            <span class="text-subtitle">支付说明</span>
            <p>
              <span style="display: inline-block; width: 100px"
                >1）支付宝支付</span
              >
              <img
                style="width: 30px; vertical-align: middle"
                src="https://resource.rcclchina.com.cn/cruiseDetail/zhifubao.png"
                alt="支付宝icon"
              />
            </p>
            <p>
              <span style="display: inline-block; width: 100px"
                >2）微信支付</span
              >
              <img
                style="width: 30px; vertical-align: middle"
                src="https://resource.rcclchina.com.cn/images/wechatPay.png"
                alt="微信支付"
              />
            </p>
            <p>
              <span style="display: inline-block; width: 100px"
                >3）银联支付</span
              >
              <img
                style="width: 30px; vertical-align: middle"
                src="https://resource.rcclchina.com.cn/cruiseDetail/unionPay.png"
                alt="银联支付"
              />
            </p>
<!--            <p>-->
<!--              4）银行转账/汇款至皇家加勒比游轮船务(中国)有限公司官方银行账户：-->
<!--              <a-->
<!--                class="morgan_bank mogenBankBtn"-->
<!--                style="cursor: pointer"-->
<!--                @click="showBankPopup"-->
<!--                >摩根大通银行账户</a-->
<!--              ><span style="color: red"> (不推荐)</span>-->
<!--              <br />-->
<!--              <span style="margin-left: 21px; display: block">-->
<!--                如果您银联支付遇到困难，也可以使用银行汇款方式付款（请在转账时备注好您的订单号、姓名、手机号）。若选择汇款，请务必在完成付款后致电400-820-7195与客服人员确认。转账/汇款无备注或未及时与客服确认，会导致订单因无法及时入账而自动取消。-->
<!--              </span>-->
<!--            </p>-->
<!--            <p>-->
<!--              5）限时活动：现在提交订单，可以选择支付订金1000/人，即可锁定航次。-->
<!--            </p>-->
            <template v-if="isDownPayCruise">
              <p>
                4）限时活动：在开航日90天(不含)前 ，可以选择支付订金1000/人起。部分航线因销售及库存等原因，可能提前关闭订金支付。享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）。
              </p>
              <p>
                5）退款说明：所支付款项将在2-5周进行原路退回。若退款金额涉及已开具纸质发票，则需要退回发票；若是电子发票，则自动作废。
              </p>
            </template>
            <template v-else>
              <p>
                4）退款说明：所支付款项将在2-5周进行原路退回。若退款金额涉及已开具纸质发票，则需要退回发票；若是电子发票，则自动作废。
              </p>
            </template>
          </dd>

          <dd class="text_bd f-fr">
            <span class="text-subtitle">发票说明</span>
            <p>
              1）
              官网预订仅可开具增值税普通发票，无法开具增值税专用发票。发票内容为“旅游服务·船票款”，不得进行修改。航次结束3个月后不得申请该航次所属的发票。
            </p>
            <p>
              2）
              官网预订仅限中国出发航次人民币船票款可开具发票。官方线下渠道使用美金支付的船票款只能开具形式发票。其它船上消费因已属境外消费，需要找船上开具账单。
            </p>
            <p>
              3）
              个人付款可开具个人抬头发票，公司转款可开具公司抬头发票（请务必通过公司账户银行转账）。个人付款如需开具公司抬头发票，需提供公司名称、税号等必要的开票信息。
            </p>
            <p>
              4）
              如因订单内容变更总金额发生变动、需要重新开发票的，预订人需先退回原发票后方可开具新的发票。
            </p>
          </dd>
        </dl>
      </div>
    </div>
    <div class="part5" id="section7">
      <div class="blur_bd_title">办理<br />登船</div>
      <div class="part5_bd">
        <dl class="text_box fix">
          <dt class="text_hd f-fl">办理登船注意事项</dt>

          <dd class="text_bd f-fl">
            <p>
              1）
              支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理<a
                href="https://www.rcclchina.com.cn/olci/Rccl.Olci/Olci/CheckInIndex"
                class="rule-item-link external"
                target="_blank"
                >在线值船</a
              >，打印“登船证”并于登船当天携带。如遇紧急情况，请您拨打皇家客服专线：400-820-7195。
            </p>
            <p>
              2） 码头办理登船时间为登船当日
              {{
                boardingTime
              }}，请您务必于该时间段内抵达码头办理登船，否则将影响您的出行。每个航次的具体登船时间请以行前短信通知为准。
            </p>
            <p>3） 码头地址：{{ portAddress }}</p>
          </dd>
        </dl>
      </div>
    </div>

    <BankPopup :isShow="isShowBankPopup" v-on:onModalClose="closeBankPopup" />
  </div>
</template>

<script>
import { SpecialBookingType } from "@/utilities/specialBookingHelper";
const NrpTable = () => import("@/components/Booking/NrpTable.vue");
const BankPopup = () => import("@/components/Booking/BankPopup.vue");
import { isHkSpecialCruise } from "@/utilities/tools";
export default {
  name: "CruiseDetailPolicy",
  components: {
    NrpTable,
    BankPopup,
  },
  props: {
    visaContent: {
      type: Object,
      default() {
        return {
          visaContent: "",
          hkGuestContent: "",
          insuranceContent: "",
          insuranceBrief: "",
        };
      },
    },
    departureCode: {
      type: String,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isSevenDayNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    shipCode: {
      type: String,
    },
    sailDate: {
      type: String,
    },
    shipName: {
      type: String,
    },
    portAddress: {
      type: String,
    },
    customClass: {
      type: String,
    },
    hasNrp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hasRp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    specialBookingInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    isDownPayCruise: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      isShowBankPopup: false,
    };
  },
  methods: {
    getCustomClass() {
      let customClass = {};
      if (this.customClass && this.customClass.length > 0) {
        customClass[this.customClass] = true;
      }
      return customClass;
    },
    showBankPopup() {
      this.isShowBankPopup = true;
    },
    closeBankPopup() {
      this.isShowBankPopup = false;
    },
  },
  computed: {
    shipLink() {
      if (this.shipCode === "WN") {
        return "https://www.rcclchina.com.cn/privilege/WN2021";
      }
      return (
        process.env.VUE_APP_BASE_URL + "/content/taste/ships/" + this.shipCode
      );
    },
    boardingTime() {
      return "11:30-15:00";
    },
    isFromGuestInfo() {
      return this.getCustomClass().guestInfo;
    },
    isBirthday() {
      if (
        this.specialBookingInfo &&
        this.specialBookingInfo.specialBookingType > 0
      ) {
        return (
          this.specialBookingInfo.specialBookingType ==
          SpecialBookingType.Birthday
        );
      }
      return false;
    },
    isShowNrp() {
      return this.shipCode != "WN";
    },
    isShowRp() {
      return true;
    },
    isHkSpecialCruise() {
      return isHkSpecialCruise(
        this.shipCode,
        this.sailDate,
        this.departureCode
      );
    },
  },
};
</script>

<style lang="less" scoped>
.part5 {
  position: relative;
  background: #fff;
  border-bottom: 15px #f5f5f5 solid;
  .part5_bd {
    min-height: 200px;
    padding: 30px 20px 20px 100px;
    .text_box {
      padding: 0px 20px 0px 0px;
      .text_hd {
        width: 10%;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        margin-right: 1%;
        padding-left: 10px;
      }
      .text_hd:after {
        content: "";
        position: absolute;
        left: 0;
        top: 4px;
        width: 3px;
        height: 15px;
        display: block;
        background: #54a3de;
      }
      .text_bd {
        width: 89%;
        line-height: 1.8;
        margin-bottom: 20px;
        .text-subtitle {
          font-size: 14px;
          color: #282b2c;
          font-weight: 700;
          position: relative;
          top: -2px;
        }
      }
    }
  }

  .blur_bd_title {
    position: absolute;
    top: 16px;
    left: -5px;
    width: 82px;
    padding: 10px 0px 20px;
    background: url(https://resource.rcclchina.com.cn/tui2/detail/part4_title_bj.png)
      no-repeat center;
    text-align: center;
    line-height: 78px;
    font-size: 20px;
    color: #fff;
    line-height: 1.2;
  }
}

.guestInfo {
  .part5_bd {
    color: #747d80;
    padding-left: 0px;
    padding-top: 0px;
    .text_box .text_hd {
      width: 16%;
      margin-right: 0px;
    }
    .text_box .text_bd {
      width: 84%;
    }
  }
  .blur_bd_title {
    display: none;
  }
  .to_ship {
    display: none;
  }
}
</style>

<style lang="less">
.part5 .part5_bd .text_box .text_bd p {
  margin: 0px;
}
.insurance_html {
  .insurance_txt {
    .visa_right__titlt {
      font-weight: bold;
      //margin-top: 16px !important;
      color: #333;
    }
  }
}
</style>
